<div class="websites-container h-100 w-100">
  <app-web-table
    [data]="websitesData()"
    [targetIndex]="effectiveIndex()"
    [isLoading]="isLoading()"
    [isProcessing]="isProcessing()"
    (activeIndexChanged)="handleIndexChanged($event)">
    
    <div table-actions class="table-actions-wrapper d-flex align-items-center h-100">
      <button class="btn-primary" 
              (click)="openWebIngestionModal()" 
              [disabled]="!activeIndexName() || isLoading() || isProcessing()">
        <span class="material-symbols-outlined">add_link</span>
        Nuova Scansione Web
      </button>

    </div>

  </app-web-table>
</div>